import React, { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import './ContactForm.css';

const ContactForm: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [captchaValue, setCaptchaValue] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!captchaValue) {
      alert('Vänligen verifiera att du är människa');
      return;
    }

    try {
      const response = await fetch('/api/submit-form', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          captchaValue
        }),
      });

      if (response.ok) {
        alert('Tack för ditt meddelande! Vi återkommer så snart som möjligt.');
        setFormData({ name: '', email: '', message: '' });
        setCaptchaValue(null);
      } else {
        const errorText = await response.text();
        console.error('Form submission failed:', response.status, errorText);
        alert(`Ett fel uppstod (${response.status}). Försök igen senare.`);
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Ett fel uppstod. Försök igen senare.');
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <form className="contact-form" onSubmit={handleSubmit}>
      <div className="form-group">
        <label htmlFor="name">Namn</label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="email">E-post</label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="message">Meddelande</label>
        <textarea
          id="message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
        />
      </div>
      <div className="form-group recaptcha-container">
        <ReCAPTCHA
          sitekey={import.meta.env.VITE_RECAPTCHA_SITE_KEY || ''}
          onChange={(value) => setCaptchaValue(value)}
        />
      </div>
      <button type="submit" disabled={!captchaValue}>
        Skicka
      </button>
    </form>
  );
};

export default ContactForm;